import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import MyEvents from './MyEvents';

const myEventsRootEl = document.getElementById('MyEvents');

if (myEventsRootEl) {
    ReactDOM.render(
        <App>
            <MyEvents dataUrl={myEventsRootEl.getAttribute('data-data-url')} eventDashboardUrl={myEventsRootEl.getAttribute('data-event-dashboard-url')} />
        </App>,
        myEventsRootEl,
    );
}
